import React from 'react';

interface SelectionButtonProps {
    label: string;
    isSelected: boolean;
    onClick: () => void;
    className?: string;
}

export const SelectionButton: React.FC<SelectionButtonProps> = ({
    label,
    isSelected,
    onClick,
    className = ""
}) => (
    <button
        type="button"
        onClick={onClick}
        className={`px-3 py-2 text-[11px] font-medium rounded-lg border transition-all duration-200 ${isSelected
            ? 'bg-indigo-600 border-indigo-600 text-white shadow-sm'
            : 'bg-white border-slate-200 text-slate-600 hover:border-indigo-300 hover:bg-slate-50'
            } ${className}`}
    >
        {label}
    </button>
);
